/*  Shared  */
import { PageNotFound } from 'application/Shared/Components/PageNotFound';
import { SessionHelper } from 'application/Shared/Helpers';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';
import { Navigate, useLocation } from 'react-router';

export const Home = () => {
    const session = useSession();

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);

    // If not logged in at all
    if (!session) {
        return (
            <Navigate
                to={{
                    pathname: '/login',
                    search
                }}
                replace
            />
        );
    }

    // If the user is logged in/has a session
    const sessionHelper = new SessionHelper(session);
    const tenant = sessionHelper.getTenant();

    const tenantId = sessionHelper.getTenantId();

    // If 'anm-trial-start' action search param is included in the URL, direct user to ANM trial wizard.
    if (searchParams.get('action') === 'anm-trial-start') {
        return (
            <Navigate
                to={{ pathname: `/partner/${tenantId}/anmTrial`, search }}
                replace
            />
        );
    }
    // If user is not setup yet
    if (tenant && (!session?.user?.configured || !session?.user?.tos)) {
        if (tenant.partner) {
            return <Navigate to="/partner/home/setup" replace />;
        }
        return <Navigate to="/home/setup" replace />;
    }

    // If tenant is a partner with system admin access.
    if (
        tenant.partner &&
        sessionHelper.isPartner() &&
        sessionHelper.hasPermission(['partner', 'system_admin'], 'and')
    ) {
        return <Navigate to={`/partner/${tenantId}/dashboard`} replace />;
    }

    if (tenantId) {
        return <Navigate to={`/admin/${tenantId}`} replace />;
    }

    // Everything else route to not found
    return <PageNotFound />;
};
